export default {
  // Endpoints
  loginEndpoint: process.env.VUE_APP_API_URL + '/api/v1/auth',
  registerEndpoint: process.env.VUE_APP_API_URL + '/api/v1/register',
  refreshEndpoint: process.env.VUE_APP_API_URL + '/api/v1/refresh-token',
  logoutEndpoint: process.env.VUE_APP_API_URL + '/api/v1/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
